var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 6.74854C0.666992 6.40048 0.925633 6.11284 1.2612 6.06731L1.35449 6.06104L15.1045 6.06104C15.4842 6.06104 15.792 6.36884 15.792 6.74854C15.792 7.09659 15.5334 7.38424 15.1978 7.42976L15.1045 7.43604L1.35449 7.43604C0.974796 7.43604 0.666992 7.12823 0.666992 6.74854Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07351 1.71326C8.80444 1.44535 8.80351 1.01005 9.07141 0.740992C9.31496 0.496389 9.69686 0.473378 9.96643 0.672498L10.0437 0.738898L15.5895 6.2609C15.8348 6.50518 15.8572 6.88845 15.6565 7.15801L15.5896 7.23522L10.0437 12.7581C9.77468 13.0261 9.33938 13.0252 9.07145 12.7561C8.82788 12.5115 8.80648 12.1296 9.00674 11.8608L9.07347 11.7839L14.1298 6.7478L9.07351 1.71326Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.a2f5cd24a2a8d7e4419bd935d22b4a3e.svg";
export { ForwardRef as ReactComponent };